/**
 * Remembers which canvas items were just created by the user, so they can
 * play the "place" animation once when they mount. Items restored by undo,
 * page loads, or imports simply appear.
 */
const PLACE_WINDOW_MS = 1000;
const recentlyPlaced = new Map();

/**
 * Mark an item id as just placed; returns the id for inline use.
 * `intent.edit` asks a new bubble to open straight into typing.
 */
export const markPlaced = (id, intent = {}) => {
  recentlyPlaced.set(id, { at: Date.now(), ...intent });
  return id;
};

/** True while an item is still within its placement window. */
export const wasJustPlaced = (id) => placementIntent(id) != null;

/** The intent an item was placed with, while still in its window. */
export const placementIntent = (id) => {
  const entry = recentlyPlaced.get(id);
  if (!entry) return null;
  if (Date.now() - entry.at > PLACE_WINDOW_MS) {
    recentlyPlaced.delete(id);
    return null;
  }
  return entry;
};
